export const YA_COUNTERS_IDS = {
  yandexCounter: 159737,
  yandexCounterWL: 87750877,
} as const;

export const YA_COUNTERS_WINDOW_NAMES = {
  yandexCounter: 'yaCounter159737',
  yandexCounterWL: 'yaCounter87750877',
} as const;

// https://yandex.ru/support/metrica/code/counter-initialize.html#counter-initialize__check-initialize
export const getYandexCounterEventName = (counterId: number) => `yacounter${counterId}inited`;
